import { connect } from 'react-redux';
import { getBlotterPanelFields, getBlotterPanelTabs } from 'state/blotters/blotterPanel/blotterPanel.selector';
import type { AppState } from 'state/state.model';

import type { BlotterPanelBodyStateProps } from './BlotterPanelBody';
import { BlotterPanelBodyComponent } from './BlotterPanelBody';

export const mapStateToProps = (state: AppState): BlotterPanelBodyStateProps => ({
  fields: getBlotterPanelFields(state),
  tabs: getBlotterPanelTabs(state),
});

export const BlotterPanelBody = connect(mapStateToProps)(BlotterPanelBodyComponent);
